import { extractFoobarReference } from '../../utils/foobar';
import {
  maxLength,
  required,
  match,
  pointInPolygon
} from '../../utils/validation';
import { formatMacAddress, normalizeMacAddress } from '../../utils/inputs';

export const LocationFieldFormat = {
  macAddress: formatMacAddress
};

export const LocationFieldNormalize = {
  macAddress: normalizeMacAddress
};

export const LocationValidations = {
  name: [
    required('models.location.name'),
    maxLength(24, 'models.location.name')
  ],
  macAddress: [
    required('models.location.locationId'),
    match(
      /([0-9a-f]{2}:){4}[0-9a-f]{2}/i,
      'models.location.locationId',
      'models.location.locationIdPlaceholder'
    )
  ],
  site: [required('models.location.site')],
  area: [required('models.location.area')],
  zone: [required('models.location.zone')],
  point: [
    required('models.location.point'),
    pointInPolygon(
      'zone.polygon',
      'models.location.point',
      'models.location.zone'
    )
  ]
};

class Serializer {
  normalize = data => {
    let props = data.assetInfo.metadata.props;
    return {
      id: data.nodeAddress,
      href: data.self.href,
      name: data.nodeName,
      initialDetectionTime: data.initialDetectionTime,
      registrationTime: data.registrationTime,
      registrationToken: data.registrationToken,
      account: data.account && {
        id: extractFoobarReference(data.account),
        href: data.account.href
      },
      macAddress: props.macAddress,
      initialProvisionedTime: props.initialProvisionedTime,
      lastProvisioned: props.lastProvisioned,
      site: { id: props.siteId },
      area: { id: props.areaId },
      zone: { id: props.zoneId },
      point: props.mapPoint ? props.mapPoint.split(',').map(Number) : []
    };
  };
  serialize = location => {
    return {
      name: location.name,
      macAddress: location.macAddress,
      siteId: location.site.id,
      areaId: location.area.id,
      zoneId: location.zone.id,
      properties: {
        mapPoint: location.point ? location.point.join(',') : ''
      },
      proxyLocations: []
    };
  };
  serializeEdit = location => {
    return {
      name: location.name,
      mapPoint: location.point ? location.point.join(',') : ''
    };
  };
  serializeDelete = location => {
    return {
      nodeAddress: location.id,
      accountId: location.account,
      siteId: location.site
    };
  };
}

export const LocationSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/location/index.js